import { atomWithMutation } from 'jotai-tanstack-query';
import { crosswordService, } from '../../services/crossword.service';
const crosswordSubmissionAtom = atomWithMutation(() => ({
    mutationKey: ['submissions'],
    mutationFn: async ({ code, data, }) => {
        await crosswordService.submitCrossword(code, data);
    },
}));
export { crosswordSubmissionAtom };
